module.exports = __webpack_public_path__ + "img/vehicle-restraints.212bdf48.svg";